import { render, staticRenderFns } from "./PnlPage.vue?vue&type=template&id=5b7a125e&scoped=true"
import script from "./PnlPage.vue?vue&type=script&lang=ts"
export * from "./PnlPage.vue?vue&type=script&lang=ts"
import style0 from "./PnlPage.vue?vue&type=style&index=0&id=5b7a125e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7a125e",
  null
  
)

export default component.exports